const odooHost =
  process.env.NODE_ENV == "production" ? "waboba" : "w-test-2023-04-23";

const AppSettings = {
  odooHost,
  odooBaseUrl: `https://${odooHost}.odoo.com`,
  productCategory: "Catalog 2025",
  lifestyleImagesCategory: "2025 Lifestyle Images",
  exchangeRateNote: null,
  odooCompanies: { AB: 1, LTD: 3 },
};

export const ODOO_COMPANY_IDS = { AB: 1, LTD: 3, UNSET: null };

export const ODOO_LTD_SOURCES = {
  10: "TRU",
  11: "SAM's",
  14: "Stock",
};

export const ODOO_WAREHOUSE_IDS = {
  // AB
  CHINA: 1,
  CAMBODIA: 20,
  // LTD
  CHINA_LTD: 18,
};

export const ODOO_OPERATION_TYPE_IDS = {
  CHINA_INTERNAL_TRANSFER: 5,
  CAMBODIA_INTERNAL_TRANSFER: 200,
};

export const ODOO_LOCATION_IDS = {
  CHINA_STOCK: 15,
  CAMBODIA_STOCK: 188,
};

export const ORIGIN_COUNTRIES = [
  {
    name: "China",
    code: "CN",
    emoji: "🇨🇳",
  },
  {
    name: "Cambodia",
    code: "KH",
    emoji: "🇰🇭",
  },
];

export default AppSettings;
